import {
  UserCog,
  CalendarCheck,
  ClipboardCheck,
  FileText,
  MapPin,
  Briefcase,
} from "lucide-react";

/**
 * Data "Mengapa Memilih Kami" (structured content).
 * Hanya klaim yang didukung informasi bisnis nyata.
 */
export const whyChooseUs = [
  {
    id: "teknisi",
    icon: UserCog,
    title: "Teknisi Berpengalaman",
    description:
      "Ditangani oleh teknisi yang memiliki pengalaman dalam pekerjaan AC dan HVAC.",
  },
  {
    id: "preventive",
    icon: CalendarCheck,
    title: "Preventive Maintenance",
    description:
      "Membantu perusahaan melakukan perawatan secara lebih terencana.",
  },
  {
    id: "survey",
    icon: ClipboardCheck,
    title: "Survey & Assessment",
    description:
      "Kebutuhan maintenance dapat diperiksa sebelum menentukan layanan.",
  },
  {
    id: "dokumentasi",
    icon: FileText,
    title: "Dokumentasi Pekerjaan",
    description:
      "Struktur dokumentasi dapat digunakan untuk mencatat pekerjaan maintenance.",
  },
  {
    id: "makassar",
    icon: MapPin,
    title: "Layanan Makassar",
    description:
      "Fokus melayani kebutuhan AC & HVAC di Makassar dan area yang dapat dijangkau.",
  },
  {
    id: "b2b",
    icon: Briefcase,
    title: "Solusi B2B",
    description:
      "Layanan diarahkan untuk kebutuhan perusahaan, gedung dan fasilitas komersial.",
  },
];

export default whyChooseUs;
